<template>
  <div class="lmy-flash onlinePackage" ref="lmyPackageBox" id="package-details" style="overflow-x: hidden">
    <div class="infinite-loading-containers" v-if="!details">
      <i class="loading-defaults"></i>
    </div>
    <div class="page-back-btn" onclick="window.history.go(-1)">
            <i class="iconfont icon-yuyin"></i>
       	</div>
    <div class="lmy-free" id="free-defaults" v-if="details">
      <div class="free-nav">
          <Swipe v-if="details.Imgs&&details.Imgs.length>0" :auto="6000">
                <SwipeItem  v-for="img in details.Imgs" :key="img.ImgUrl" :auto="6000">
                    <img :src="img.ImgUrl" :alt="img.ImgUrl"/>
                </SwipeItem>
          </Swipe>
          <Swipe v-else>
                <SwipeItem>
                    <img src="../../assets/img/hotelDetailsDf.png"/>
                </SwipeItem>
          </Swipe>
      </div>
      <div class="bannerTag" style="right: 0;left: auto;">
          <p class="red" v-if="details.Type==1">优惠度假</p>
          <p class="orange" v-else>超值预售</p>
      </div>
      <div class="flash-content" style="box-shadow: none;border-radius: 0;margin-bottom: 0;">
        <div class="price" v-if="details.Price||details.SaleStart">
          <div class="text">￥<span class="number">{{details.Price||' XX '}}</span> 起</div>
          <div>
            <div class="time" v-if="(dateIntervene(details.SaleStart)<=0)&&details.clockHour&&(details.clockHour<48)">
              <span class="on" v-if="details.clockEnd">距结束 :</span>
              <span class="under" v-html="details.clockEnd"></span>
            </div>
            <div class="time" v-if="dateIntervene(details.SaleStart)>0">
              <span class="on" v-if="details.clockStart">距开售 :</span>
              <span class="under" v-html="details.clockStart"></span>
            </div>
          </div>
        </div>
      </div>
      <div class="flash-sum-a">
          <div class="info">
              <p class="title">{{details.ProductName}}</p>
              <div class="box" style="margin-top: 0.15rem;" v-if="details.Tags&&details.Tags.length>0"><div class="PackageTag">{{details.Tags[0]}}</div></div>
          </div>
      </div>
     
      <div class="free-content">
        <div class="infinite-loading-containers" v-if="ShowSKU">
          <i class="loading-defaults"></i>
        </div>
        <div class="lmy-pur-content" v-if="SKUdata.length>0">
          <div class="room-people-toast"><span>您选择的产品：</span><span class="free-product-name">{{Name||'您还未选择产品'}}</span></div>
          <div class="content-head">套餐类型</div>
          <div class="combo-box">
            <span v-for="SKU,index in SKUdata" :key="index" :class="activeCombo==SKU.SkuId?'combo active':'combo'" @click="handleCombo(SKU)">{{SKU.SkuName}}</span>
            <div style="position: relative;" v-if="packageBookInfo.SimpleDescribe">
              <div class="boxImg"><img src="../../assets/img/hint.png" alt="" srcset=""></div>
              <div class="box" style="padding-left: 0.5rem">
                <div class="PackageTag" :class="{scroll:isScroll}" v-html="packageBookInfo.SimpleDescribe" ref="longName" id="package-scroll"></div>
              </div>
            </div>
          </div>
        </div>
        <div v-else style="text-align: center; padding:0 .35rem;font-weight:bold;color:red;">暂无可售的度假套餐</div>

        <div class="lmy-pur-content" v-if="SKUdata.length>0">
          <div class="content-head">游玩日期</div>
        </div>

        <div class="lmy-ticket-list" style='margin-bottom: 0.3rem;' v-if="SKUdata.length>0">
          <div v-if="details.Type==1" style="margin: 0.2rem 0;font-size: .28rem;">您选择的出发日期为：<span style="font-weight: bold;">{{changeDate}}</span></div>
          <div v-else style="margin: 0.2rem 0;font-size: .28rem;">
            <span>{{packageBookInfo.ReserveDay>0?'至少提前'+packageBookInfo.ReserveDay+'天预约，':(packageBookInfo.ReserveHour=='23:59'?'':'需当日'+packageBookInfo.ReserveHour+'前预定， ')}}</span>
            有效期至 <span style="font-weight: bold;">{{details.BookingEnd|dateToYMDline}}</span></div>
          <div style="margin: 0.2rem 0;font-size: .28rem;color:#eb3941;" v-if="AllowCancel==false&&details.Type==1">此订单即订即保，订单一经确认，不可取消更改</div>
          <div style="margin: 0.2rem 0;font-size: .28rem;color:#eb3941;" v-if="AllowCancel&&details.Type==1&&CancelDate">最后可取消时间为：{{CancelDate}}</div>
          <div class="list-content" v-if="details.Type==1&&!isDaily&&dailyData&&dailyData.length>0">
              <div class="date-list">
                <div :class="item.isBook?(mySelectIndex===index?'list-item active':'list-item'):'list-item disabled'" v-for="(item,index) in list" @click="select(item,index)">
                  <p>{{item.Date|dateToYMDline|dateWeek}}</p>
                  <p>{{item.Date|dateMMtDD}}</p>
                  <p>{{item.isBook?('¥'+item.Price):(details.Type==2?'不可约':'不可订')}}</p>
                </div>
                <div class="more" @click="moreDates"><i class="iconfont icon-more"></i></div>
              </div>
          </div>
          <div v-if="details.Type==2" style="font-size: 0.28rem;">
            产品支持预约前 <span style="font-size: 0.24rem;color: #fb8801;display: inline-block;padding: 3px;background: #fff6eb;"> 随时退 </span> ，过期未预约 <span style="font-size: 0.24rem;color: #fb8801;display: inline-block;padding: 3px;background: #fff6eb;"> 全额退 </span>。
          </div>
          <div v-if="details.Type==2&&!isDaily&&dailyData&&dailyData.length>0" @click="moreDates" style="font-size: 0.28rem;margin: 0.2rem 0;">
            产品为预售产品，您可以提前<span style="color: #2591fd;">查看可预约日期</span>。
          </div>

          <div class="infinite-loading-containers" v-if="isDaily">
            <i class="loading-defaults"></i>
          </div>
        </div>

        <div v-if="packageBookInfo&&packageBookInfo.SkuPieces.length>0">
          <div class="lmy-pur-content">
            <div class="content-head">产品包含</div>
            <ul style='list-style: disc;'>
              <li class="content-body" v-for="S,index in packageBookInfo.SkuPieces" :key="index"  v-html="S"></li>
            </ul>
          </div>
        </div>
        <div class="lmy-pur-content" v-if="details.Type==2">
          <div class="content-head">预售说明</div>
          <div class="content-body" v-for="R,index in details.Rule" :key="index" v-if="index=='抢购时间'">
            <span>{{index}}</span>：<span>{{R}}</span>
          </div>
          <div class="content-body" v-for="R,index in details.Rule" :key="index" v-if="index=='预约时间'">
            <span>{{index}}</span>：<span>{{R}}</span>
          </div>
          <div class="content-body" v-if="packageBookInfo&&packageBookInfo.ValidStart&&packageBookInfo.ValidEnd">
            <span>入住时间</span>：<span>{{packageBookInfo.ValidStart|dateToYMDline}}到{{packageBookInfo.ValidEnd|dateToYMDline}}</span>
          </div>
          <div class="content-body" v-if="packageBookInfo&&packageBookInfo.TimeLimitType">
              <div style="margin-left: 5em;color:#eb3941;font-weight:bold;position: relative;">
                <span style="position: absolute;top: 0;left: -5em;">适用限制：</span>
                {{timeTip}}
              </div>
          </div>
          <div class="content-body" v-for="R,index in details.Rule" :key="index" v-if="index=='自动取消'">
            <span>{{index}}</span>：<span>{{R}}</span>
          </div>
        </div>

        <div v-for="N,index in details.Notice" :key="index" v-if="index=='产品亮点'">
          <div class="lmy-pur-content">
            <div class="content-head">{{index}}</div>
            <div class="content-body" v-html="N"></div>
          </div>
        </div>
        <div v-for="N,index in details.Notice" :key="index" v-if="index=='购买须知'">
          <div class="lmy-pur-content">
            <div class="content-head">{{index}}</div>
            <div class="content-body" v-html="N"></div>
          </div>
        </div>
        
        <div class="lmy-pur-content">
          <div class="content-head">图文介绍</div>
          <div class="content-body" v-for="D,index in details.DetailImgs" :key="index">
            <div class="detailTitle">{{D.Title}}</div>
            <div class="detailImg"><img :src="D.ImgUrl" :alt="D.ImgUrl"/></div>
            <div class="detailText" v-html="D.Describe"></div>
          </div>
        </div>

        <div v-for="N,index in details.Notice" :key="index" v-if="index=='特别说明'">
          <div class="lmy-pur-content">
            <div class="content-head">{{index}}</div>
            <div class="content-body" v-html="N"></div>
          </div>
        </div>
      </div>


      <div class="book-comfirming" v-if="isSubmit">
        <div class='f-modal' >
          <div class='f-modal-head'>提示</div>
          <div class='f-modal-body'>
            <p>正在核实产品信息，请稍候</p>
          </div>
        </div>
      </div>

      <div class="free-footer" v-if="!IsFromPC">
        <div v-if="Price&&isCheck" class="price"><span style="color:#f37a28">￥ <span style="font-weight: bold; font-size: 0.4rem;">{{Price}}</span></span> /份</div>
        <div v-else>该套餐暂已售罄</div>
        <!-- <div class="service" @click="openContact">
          <i class="iconfont icon-kefu"></i>
        </div> -->
        <div class="submit" v-if="Price&&isCheck" @click="checkBookAble">{{details.Type==2?'去抢购':'去支付'}}
        </div>
        <div class="submit" v-else style="background-color: #5f5f5e;">{{details.Type==2?'去抢购':'去支付'}}
        </div>
      </div>

    </div>
    <DailyData :dailyData="dailyData" :handleDate="handleDate" @selectday="selectday" v-show="isDailyDataShow" :PackageType='details.Type'></DailyData>
  </div>
</template>

<script>
require("vue-swipe/dist/vue-swipe.css");
import DailyData from "./cmpnt/dailyData"; //价格日历
// in CommonJS
const { Swipe, SwipeItem } = require("vue-swipe");
export default {
  name: "free-details",
  components: {
    SwipeItem,
    Swipe,
    DailyData
  },
  data() {
    return {
      ShowSKU: false,
      details: "",
      SKUdata: "",
      activeCombo: "",
      Price: "",
      Token: "",
      Name: "",
      packageBookInfo: "",
      isSubmit: false,
      CustomerNO:'BJ100138',
      ProductId: this.$route.query.ProductId,
      // 日历数据
      dailyData: [],
      mySelect: "",
      mySelectIndex: "",
      handleDate: "",
      changeDate: "",
      isDaily: false,
      isDailyDataShow: false,
      isScroll: false,
      isCheck:true,
      timeTip:'',
      AllowCancel:'',
      CancelDate:'',
      IsFromPC:false
    };
  },
  methods: {
    handleCombo(SKU) {
      this.Name = SKU.SkuName;
      this.activeCombo = SKU.SkuId;
      if (this.details.Type!=1 && SKU.Price && Number(SKU.Price)) {
        this.Price = Number(SKU.Price).toFixed(2);
      }
      switch (SKU.TimeLimitType) {
          case 1:
              this.timeTip = "周末、平日通用(周一,周二,周三,周四,周五,周六,周日)";
              break;
          case 2:
              this.timeTip = "平日适用(周一,周二,周三,周四,周五)";
              break;
          case 3:
              this.timeTip = "平日适用(周日,周一,周二,周三,周四)";
              break;
          case 4:
              this.timeTip = "周末适用(周五,周六)";
              break;
          case 5:
              this.timeTip = "周末适用(周六,周日)";
              break;
          case 6:
              this.timeTip = "周五适用";
              break;
          case 7:
              this.timeTip = "周六适用";
              break;
          case 8:
              this.timeTip = "周日适用";
              break;
          case 9:
              this.timeTip = "平日适用(周日,周一,周二,周三,周四,周五)";
              break;
          case 10:
              this.timeTip = "平日适用(周一,周二,周三,周四)";
              break;
      }
      this.packageBookInfo = SKU;
      this.getPackageDaily(SKU);
      this.getTextWidth()
      this.ShowSKU = false;
    },
    getTextWidth(){
      var that = this
      that.$nextTick(() => {
        that.isScroll = false
        if((that.$refs.longName.clientWidth)>(6.7*50)){
          that.isScroll = true
        }else{
          that.isScroll = false
        }
      })
    },
    getSKUs(params) {
      var that = this;
      that.ShowSKU = true;
      // params.ProductType= 1
      that
        .postRequest({
          url: that.Api.getOnlinePackageSKUs,
          params: params
        })
        .then(res => {
          if (res && res.IsSuccess) {
            var data = res.Result;
            var arr = [];
            data.forEach(item => {
              item.SKU.Token = item.Token;
              arr.push(item.SKU);
            });
            that.SKUdata = arr;
            that.handleCombo(that.SKUdata[0]);
          } else {
            that.SKUdata = "";
            // that.error({ title: "提示", content: res.Msg || "暂无套餐可售！" });
          }
          that.ShowSKU = false;
        });
    },
    initData() {
      var that = this;
      that.dao.set("packageDetailId", JSON.stringify(that.ProductId));
      var params = {
        CustomerNO:that.CustomerNO,
        productId: that.ProductId,
        IsFromPC:that.IsFromPC,
      };
      that
        .postRequest({
          url: that.Api.getOnlinePackageDetail,
          params: params
        })
        .then(res => {
          if (res && res.IsSuccess) {
            that.details = res.Result;
            if (that.details.Imgs&&that.details.Imgs.length > 10) {
              that.details.Imgs = that.details.Imgs.splice(0, 10);
            }
            that.dao.set("packageDetails", JSON.stringify(that.details));
            that.timeLoop(that.details, that.details.SaleStart, that.details.SaleEnd)
            that.getSKUs(params);
          } else {
            this.details = "";
            this.error(
              { title: "提示", content: res.Msg || "产品已过期！"},
              function() {
                window.history.go(-1);
              }
            );
          }
        });
    },
    timeLoop(item, start, end) {
      var num = 1;
      var that = this;
      var end = that.dateIntervene(end);
      var start = that.dateIntervene(start);
      var time = setInterval(function() {
        num++;
        if (num >= end) {
          clearInterval(time);
        } else {
          var hour = that.betDateH(end - num)
          that.$nextTick(function() {
            if(start>0){
              that.$set(item, "clockStart", that.betDateFomate(start - num));
            }else if(start<=0&&hour<48){
              that.$set(item, "clockHour", hour);
              that.$set(item, "clockEnd", that.betDateFomate(end - num));
            }
          });
        }
      }, 1000);
    },
    dateIntervene(date) {
      var s1 = new Date().getTime();
      var s2 = new Date(date).getTime();
      return parseInt((s2 - s1 > 0 ? s2 - s1 : 0) / 1000);
    },
    betDateH(time){
      return Math.floor((time / 60 / 60));
    },
    betDateFomate(time) {
      var d, h, m, s;
      if (time >= 0) {
        d = Math.floor(time / 60 / 60 / 24);
        h = Math.floor((time / 60 / 60) % 24);
        m = Math.floor((time / 60) % 60);
        s = Math.floor(time % 60);
      }
      var intv =
        "<span>" +
        d +
        "</span> 天 <span>" +
        (h < 10 ? "0" + h : h) +
        "</span> : <span>" +
        (m < 10 ? "0" + m : m) +
        "</span> : <span>" +
        (s < 10 ? "0" + s : s);

      return intv;
    },
    select(item, index) {
      if(this.details.Type==2) return
      if (!item.isBook){
        // this.isCheck=false
        return
      } 
      this.isCheck = true
      this.mySelect = item;
      this.mySelectIndex = index;
      this.changeDate = item.Date;
      this.Price = item.Price
      this.Token = item.Token
      this.AllowCancel = item.AllowCancel
      this.CancelDate = item.CancelDate
    },
    moreDates() {
      this.isDailyDataShow = true;
      if (this.mySelect) {
        this.handleDate = this.mySelect.Date;
      } else {
        this.handleDate = this.dailyData[0].Date;
      }
    },

    //选择其它日期的价格
    selectday(day,item) {
      if(day){
        var data = this.dailyData;
        this.changeDate = day;
        this.Price = item.Price
        this.Token = item.Token
        data.forEach((item, index) => {
          if (item.Date == day) {
            if (index == data.length - 1) {
              this.list = data.slice(-5);
              this.mySelect = this.list[4];
              this.mySelectIndex = 4;
            } else {
              this.list = data.slice(index, index + 5);
              this.mySelect = this.list[0];
              this.mySelectIndex = 0;
            }
          }
        });
      }
      this.isDailyDataShow = false;
    },

    //获取价格日历
    getPackageDaily(sku) {
      var that = this;
      var start = ''
      if(that.getDays(that.dateToYMDline(sku.ValidStart),that.getDate(0))>0){
        start = that.getDate(0)
      }else{
        start = that.dateToYMDline(sku.ValidStart)
      }
      var params = {
        CustomerNO:that.CustomerNO,
        HotelID: sku.HotelId,
        RoomID: sku.RoomId,
        RPID: sku.RpId,
        RateID: sku.RateId,
        ProductID: sku.ProductId,
        SKUID: sku.SkuId,
        Start: start,
        IsFromPC:that.IsFromPC,
        End: that.dateToYMDline(sku.ValidEnd)
      };
      that.isDaily = true;
      that
        .postRequest({
          url: that.Api.getOnlinePackagePrices,
          params: params
        })
        .then(res => {
          that.isDaily = false;
          that.ShowSKU = false;
          if (res && res.IsSuccess) {
            var data = res.Result.reverse();
            var arr = [];
            data.forEach(item => {
              if(!item.Status){
                if(item.IsAskRoom||(!item.IsAskRoom&&item.Stock>0)){
                  item.isBook=true
                }else{
                  item.isBook=false
                }
              }else {
                item.isBook=false
              }
              item.Date = item.Date.slice(0, 10);
              arr.push(item);
            });
            that.dailyData = arr;
            var index = 0
            var flag=true
            for(var i = 0;i<arr.length;i++){
              if(arr[i].isBook&&flag){
                index = i
                flag = false
              }
            }
            if (arr.length-(index+1) >= 5) {
              that.list = arr.slice(index, index+5);
            } else {
              that.list = arr.slice(index);
            }
            if(that.details.Type==1){
              that.select(that.list[0], 0);
            }else{
              that.packageBookInfo.HandleItem = that.list[0]
              that.dao.set(
                "packageBookInfo",
                JSON.stringify(this.packageBookInfo)
              );
            }
            
          } else {
            this.dailyData = "";
            that.SKUdata.forEach(item => {
              item.active = false;
            });
            this.error({
              title: "提示",
              content: "该套餐已售罄！"
            });
            this.Price=''
          }
        });
    },

    getMothDay(day) {
      if (day) {
        var d = new Date(day);
        var m =
          d.getMonth() + 1 < 10 ? "0" + (d.getMonth() + 1) : d.getMonth() + 1;
        var d1 = d.getDate() < 10 ? "0" + d.getDate() : d.getDate();
        return m + "/" + d1;
      } else {
        return "";
      }
    },
    checkBookAble() {
      var that = this;
      if(that.details.Type==2){
        this.$router.push("/packageBook");
        return
      }
      if (!that.packageBookInfo) {
        that.error({ title: "提示", content: "您尚未选购套餐" });
        return;
      }
      var Token = that.details.Type==2?that.packageBookInfo.Token:that.Token
      if (!Token) {
        that.error({ title: "提示", content: "该日期已无法被购买" });
        return;
      }
      var dateTime
      if(that.mySelect.Date){
        dateTime = new Date(that.mySelect.Date)
        dateTime = dateTime.setDate(dateTime.getDate()+1)
        dateTime = new Date(dateTime)
        dateTime = that.dateToYMDline(dateTime)
      }
      that.isSubmit = true;
      var param = {
        token: Token,
        Count: 1,
        CheckIn: that.mySelect.Date||that.getDate(0),
        CheckOut: dateTime||that.getDate(1)
      };
      that
        .postRequest({
          url: that.Api.getOnlinePackageCheck,
          params: param
        })
        .then(res => {
          that.isSubmit = false;
          if (res.IsSuccess) {
            that.packageBookInfo.HandleItem = that.mySelect
            that.dao.set(
              "packageBookInfo",
              JSON.stringify(this.packageBookInfo)
            );
            this.$router.push("/packageBook");
          } else {
            that.error({ title: "提示", content: res.Msg || "不能预订" });
          }
        });
    },
    backToLastPage() {
      var fromList = this.$route.query.fromList;
      if (fromList) {
        window.history.go(-1);
      } else {
        this.$router.push("/");
      }
    }
  },
  created() {
    var number = this.$route.query.CustomerNO
    var isFromPC = this.$route.query.IsFromPC
    if(number){
      this.CustomerNO = number
    }
    if(isFromPC){
      this.IsFromPC = isFromPC
    }
    this.initData();
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/free/details.vue